"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpStudentsDetailsQuestionAttemptModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var api_1 = require("../../../api");
var react_i18next_1 = require("react-i18next");
var TruncatedTooltip_1 = require("../Tooltip/TruncatedTooltip");
var Icon_1 = require("../Icon/Icon");
var DpModal_1 = require("../Modal/DpModal");
var assets_1 = require("../../../assets");
var DpStudentsDetailsQuestionAttemptModal_styled_1 = require("./DpStudentsDetailsQuestionAttemptModal.styled");
var AtomicAlertManagerContext_1 = require("../AtomicAlert/AtomicAlertManagerContext");
var image_1 = __importDefault(require("next/image"));
var AttemptTab = function (_a) {
    var className = _a.className, onClick = _a.onClick, status = _a.status, text = _a.text, disabled = _a.disabled, ariaSelected = _a.ariaSelected;
    return ((0, jsx_runtime_1.jsxs)(DpStudentsDetailsQuestionAttemptModal_styled_1.StyledTab, { className: "btn-clearfix ".concat(className), onClick: onClick, status: status, disabled: disabled, role: "tab", "aria-selected": ariaSelected, children: [(0, jsx_runtime_1.jsx)("div", { className: "dot" }), (0, jsx_runtime_1.jsx)("div", { className: "text", children: text })] }));
};
var AttemptTabList = function (_a) {
    var attempts = _a.attempts, currentAttemptId = _a.currentAttemptId, disabled = _a.disabled, onClickAttempt = _a.onClickAttempt, className = _a.className;
    return ((0, jsx_runtime_1.jsx)("div", { className: className, role: "tablist", children: attempts.map(function (attempt, index) { return ((0, jsx_runtime_1.jsx)(AttemptTab
        // @ts-ignore
        , { status: attempt.status, text: "Attempt ".concat(attempts.length - index), className: attempt.attemptId === currentAttemptId ? 'selected' : '', onClick: function () {
                onClickAttempt(attempt.attemptId);
            }, disabled: disabled, ariaSelected: attempt.attemptId === currentAttemptId }, attempt.attemptId)); }) }));
};
var DpStudentsDetailsQuestionAttemptModal = function (_a) {
    var contextId = _a.contextId, assessmentTemplateId = _a.assessmentTemplateId, curriculumId = _a.curriculumId, itemExternalId = _a.itemExternalId, showStudentAttemptQuestionModal = _a.showStudentAttemptQuestionModal, openQuestionModal = _a.openQuestionModal, currentQuestionSelectedItem = _a.currentQuestionSelectedItem, assigneesPerformance = _a.assigneesPerformance, assessmentTitle = _a.assessmentTitle, studentId = _a.studentId;
    var toast = (0, react_1.useContext)(AtomicAlertManagerContext_1.AtomicAlertManagerContext).toast;
    var _b = (0, react_1.useState)(false), lernosityQuestionIsRendering = _b[0], setLernosityQuestionRendering = _b[1];
    var _c = (0, react_1.useState)(false), lernosityScriptLoaded = _c[0], setLernosityScriptAvailability = _c[1];
    var _d = (0, react_1.useState)([]), studentsData = _d[0], setStudentsData = _d[1];
    var _e = (0, react_1.useState)([]), sortedStudentsList = _e[0], setSortedStudentsList = _e[1];
    var _f = (0, react_1.useState)(null), attemptId = _f[0], setAttemptId = _f[1];
    var _g = (0, react_1.useState)(), selectedAssignee = _g[0], setSelectedAssignee = _g[1];
    var _h = (0, react_1.useState)(false), isEmptyState = _h[0], setIsEmptyState = _h[1];
    var _j = (0, react_1.useState)({ assignees: null, attempts: null }), dictionary = _j[0], setDictionary = _j[1];
    var _k = (0, react_1.useState)({
        direction: api_1.SortDirectionEnumerables.ascending,
        property: 'fullName',
    }), sortingCriteria = _k[0], setSortingCriteria = _k[1];
    var lastStudent = (0, react_1.useRef)(null);
    var itemAPIStatus = (0, api_1.useScript)(api_1.ITEMS_API_URL);
    var _l = (0, react_1.useContext)(api_1.ServiceContext), analyticsService = _l.analyticsService, learnosityService = _l.learnosityService;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var primaryText = t('studentAttemptQuestionModal.emptyData.questionUnattempted');
    // ---------------------------- Methods
    var getAttemptResultStatus = function (item) {
        return item.isCorrect
            ? api_1.ItemResponseStatus.Correct
            : item.isPartiallyCorrect
                ? api_1.ItemResponseStatus.PartiallyCorrect
                : api_1.ItemResponseStatus.Incorrect;
    };
    // ---------------------------- Events
    var getIconName = function (responseStatus) {
        return responseStatus === api_1.ItemResponseStatus.Correct
            ? 'check'
            : responseStatus === api_1.ItemResponseStatus.PartiallyCorrect
                ? 'minus'
                : 'x';
    };
    var fetchCurrentStudentQuestionAttempt = function (assigneeId) {
        if (selectedAssignee.assigneeId === assigneeId)
            return;
        var newSelectedAssignee = dictionary.assignees.get(assigneeId);
        setSelectedAssignee(newSelectedAssignee);
        setAttemptId(newSelectedAssignee.attemptId);
    };
    (0, react_1.useEffect)(function () {
        var student = lastStudent.current;
        if (student) {
            student.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }, [attemptId, sortedStudentsList]);
    var processStudentPerformances = function (studentPerformances) {
        var assignees = new Map();
        var attempts = new Map();
        var newStudentsData = [];
        studentPerformances.forEach(function (studentPerformance) {
            // Preparing assignee
            var assigneeAlreadyPresent = assignees.get(studentPerformance.assigneeId);
            var assignee = assigneeAlreadyPresent;
            // Found new assignee: attempts are yet to be added, hence initializing attempts list to []
            if (!assigneeAlreadyPresent) {
                assignee = studentPerformance;
                assignee.attempts = [];
            }
            // Preparing attempt
            var attemptAlreadyPresent = attempts.get(studentPerformance.attemptId);
            var attempt = attemptAlreadyPresent;
            // Combining attempts with same attempt id
            if (attemptAlreadyPresent) {
                attempt.maxScore += studentPerformance.maxScore;
                attempt.score += studentPerformance.score;
            }
            else {
                // Found new attempt
                attempt = studentPerformance;
                // attempt.attemptIndex = assignee.attempts.length;
                assignee.attempts.push(attempt); // adding attempt to the assignee
                attempts.set(studentPerformance.attemptId, attempt);
            }
            // Found new assignee: attempts addition completed
            if (!assigneeAlreadyPresent) {
                assignees.set(studentPerformance.assigneeId, assignee);
                newStudentsData.push(assignee);
            }
        });
        // Update status of each attempt
        attempts.forEach(function (attempt) {
            attempt.status = getAttemptResultStatus(attempt);
        });
        // Updating status of each assignee
        newStudentsData.forEach(function (assignee) {
            assignee.status = assignee.attempts[0].status; // status for the latest attempt i.e. 0th attempt
        });
        // Updating fullName for each assignee
        assigneesPerformance.forEach(function (assigneePerformance) {
            var assigneeAttempt = assignees.get(assigneePerformance.assignee.id);
            if (assigneeAttempt) {
                assigneeAttempt.fullName = "".concat(assigneePerformance.assignee.lastName, ", ").concat(assigneePerformance.assignee.firstName);
            }
        });
        setStudentsData(newStudentsData);
        setDictionary({ assignees: assignees, attempts: attempts });
        var criteria = {
            property: 'fullName',
            direction: api_1.SortDirectionEnumerables.ascending,
        };
        setSortingCriteria(criteria);
        var sortedStudents = sortStudents(criteria, newStudentsData);
        var selectedStudent = studentId ? assignees.get(studentId) : sortedStudents[0];
        setSelectedAssignee(selectedStudent);
        setAttemptId(selectedStudent.attemptId);
    };
    var questionResponseStatus = function (status) {
        return status === api_1.ItemResponseStatus.Correct
            ? 'Correct'
            : status === api_1.ItemResponseStatus.PartiallyCorrect
                ? 'partially correct'
                : 'incorrect';
    };
    var sortStudents = function (criteria, students) {
        var studentsList = students || studentsData;
        if (!studentsList.length)
            return;
        var copyStudentList = __spreadArray([], studentsList, true);
        copyStudentList.sort((0, api_1.sortByCriteria)(criteria));
        setSortedStudentsList(copyStudentList);
        return copyStudentList;
    };
    // Event called when sorting icon is clicked.
    var sortingCriteriaClicked = (0, react_1.useCallback)(function (property) {
        var criteria;
        var sortDirection = api_1.SortDirectionEnumerables.ascending;
        // Define the direction
        if (sortingCriteria.property !== property) {
            sortDirection = api_1.SortDirectionEnumerables.ascending;
        }
        else {
            sortDirection =
                sortingCriteria.direction === api_1.SortDirectionEnumerables.ascending
                    ? api_1.SortDirectionEnumerables.descending
                    : api_1.SortDirectionEnumerables.ascending;
        }
        // Set values for new criteria
        if (!sortingCriteria) {
            // default value
            criteria = {
                property: 'fullName',
                direction: api_1.SortDirectionEnumerables.ascending,
            };
        }
        else {
            criteria = {
                property: property,
                direction: sortDirection,
            };
        }
        setSortingCriteria(criteria);
        sortStudents(criteria);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sortingCriteria, setSortingCriteria]);
    var hideModal = (0, react_1.useCallback)(function () {
        openQuestionModal(null);
        setAttemptId(null);
        setIsEmptyState(false);
    }, [openQuestionModal, setAttemptId, setIsEmptyState]);
    var getSortableButton = (0, react_1.useCallback)(function (columnLabel, property) { return ((0, jsx_runtime_1.jsxs)("button", { onClick: function () { return sortingCriteriaClicked(property); }, className: "btn-clearfix sortable-button", children: [columnLabel, (sortingCriteria === null || sortingCriteria === void 0 ? void 0 : sortingCriteria.property) === property ? ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: (sortingCriteria === null || sortingCriteria === void 0 ? void 0 : sortingCriteria.direction) === api_1.SortDirectionEnumerables.ascending
                    ? "arrow-up"
                    : "arrow-down" })) : ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "up-down" }))] })); }, [sortingCriteria, sortingCriteriaClicked]);
    var getAriaSort = function (property) {
        if (sortingCriteria.property === property) {
            return sortingCriteria.direction === api_1.SortDirectionEnumerables.ascending
                ? 'ascending'
                : 'descending';
        }
        return 'none';
    };
    var lernositySign = (0, react_1.useCallback)(function (attemptID) {
        setLernosityQuestionRendering(true);
        learnosityService
            .signReviewAttemptRequest(attemptID, [
            {
                id: currentQuestionSelectedItem === null || currentQuestionSelectedItem === void 0 ? void 0 : currentQuestionSelectedItem.externalId,
                reference: currentQuestionSelectedItem === null || currentQuestionSelectedItem === void 0 ? void 0 : currentQuestionSelectedItem.externalBankItemId,
            },
        ], undefined, undefined, undefined, curriculumId)
            .then(function (signed) {
            learnosityService.initLernosityItemApi(signed, {}, function () {
                setLernosityQuestionRendering(false);
            });
        })
            .catch(function () {
            setLernosityQuestionRendering(false);
            toast({
                alertVariant: 'error',
                content: {
                    title: t('errorMessages.oopsErr'),
                    message: t('errorMessages.loadQuestion'),
                },
            });
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [learnosityService, currentQuestionSelectedItem]);
    // Pull students list when modal is opened
    (0, react_1.useEffect)(function () {
        if (itemExternalId && showStudentAttemptQuestionModal) {
            setStudentsData([]);
            setSortedStudentsList([]);
            analyticsService
                .getAssessmentStudentsItemPerformance(contextId, assessmentTemplateId, itemExternalId)
                .then(function (studentItemPerformances) {
                studentItemPerformances.length
                    ? processStudentPerformances(studentItemPerformances)
                    : setIsEmptyState(true);
            })
                .catch(function () {
                toast({
                    alertVariant: 'error',
                    content: {
                        title: t('errorMessages.oopsErr'),
                        message: t('errorMessages.loadStudents'),
                    },
                });
            });
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        showStudentAttemptQuestionModal,
        analyticsService,
        assessmentTemplateId,
        contextId,
        itemExternalId,
    ]);
    // Step 1: ensure lernosity script is loaded
    (0, react_1.useEffect)(function () {
        if (itemAPIStatus === 'ready') {
            setLernosityScriptAvailability(true);
        }
    }, [itemAPIStatus]);
    // Step 2: call lernosity sign api if attemptId is changed
    (0, react_1.useEffect)(function () {
        if (attemptId) {
            lernositySign(attemptId);
        }
    }, [attemptId, lernositySign]);
    return (showStudentAttemptQuestionModal &&
        lernosityScriptLoaded && ((0, jsx_runtime_1.jsxs)(DpStudentsDetailsQuestionAttemptModal_styled_1.StyledDpStudentsDetailsQuestionAttemptModal, { show: showStudentAttemptQuestionModal, onHide: hideModal, size: "lg", scrollable: true, "aria-labelledby": "student-item-latest-performance-data-modal", children: [(0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Header, { children: (0, jsx_runtime_1.jsx)("h1", { id: "student-item-latest-performance-data-modal", className: "h3", "aria-label": t('studentAttemptQuestionModal.ariaLabel.heading', {
                        assessmentName: assessmentTitle,
                    }), children: assessmentTitle }) }), (0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Body, { children: sortedStudentsList.length ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "question-tab-wrapper", children: [(0, jsx_runtime_1.jsxs)("div", { className: "question-label", children: [(0, jsx_runtime_1.jsx)("span", { className: "visually-hidden", children: "Question ".concat(currentQuestionSelectedItem.label) }), (0, jsx_runtime_1.jsx)("span", { "aria-hidden": "true", className: "question-label", children: t('studentAttemptQuestionModal.question', {
                                                count: currentQuestionSelectedItem.label,
                                            }) })] }), (selectedAssignee === null || selectedAssignee === void 0 ? void 0 : selectedAssignee.attempts.length) > 1 && ((0, jsx_runtime_1.jsx)(AttemptTabList, { className: "tabs", attempts: selectedAssignee.attempts, disabled: lernosityQuestionIsRendering, onClickAttempt: setAttemptId, currentAttemptId: attemptId }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "questions-student-list-container", children: [(0, jsx_runtime_1.jsx)("div", { className: "left", children: (0, jsx_runtime_1.jsx)("div", { "aria-label": t('studentAttemptQuestionModal.questionContent', {
                                            count: currentQuestionSelectedItem.label,
                                        }), className: "learnosity-item-wrapper", tabIndex: 0, children: (0, jsx_runtime_1.jsx)("div", { className: "learnosity-item", "data-reference": currentQuestionSelectedItem === null || currentQuestionSelectedItem === void 0 ? void 0 : currentQuestionSelectedItem.externalBankItemId }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "student-data-items", children: (0, jsx_runtime_1.jsxs)("table", { children: [(0, jsx_runtime_1.jsxs)("caption", { children: [(0, jsx_runtime_1.jsx)("span", { className: "visually-hidden", children: t('studentAttemptQuestionModal.ariaLabel.tableCaption') }), (0, jsx_runtime_1.jsx)("span", { children: t('studentAttemptQuestionModal.ariaLabel.tableWarning') })] }), (0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { role: "row", children: [(0, jsx_runtime_1.jsx)("th", { role: "columnheader", className: "status", scope: "col", "aria-sort": getAriaSort('score'), children: getSortableButton(t("studentAttemptQuestionModal.result"), 'score') }), (0, jsx_runtime_1.jsx)("th", { className: "student-name-header", scope: "col", "aria-sort": getAriaSort('fullName'), children: getSortableButton(t('studentAttemptQuestionModal.studentName'), 'fullName') })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: sortedStudentsList.map(function (student, studentIndex) { return ((0, jsx_runtime_1.jsxs)("tr", { onClick: function () {
                                                        return lernosityQuestionIsRendering
                                                            ? null
                                                            : fetchCurrentStudentQuestionAttempt(student.assigneeId);
                                                    }, className: "student-item ".concat(lernosityQuestionIsRendering ? 'disabled' : ''), onKeyDown: function (e) {
                                                        return e.key === 'Enter' && !lernosityQuestionIsRendering
                                                            ? fetchCurrentStudentQuestionAttempt(student.assigneeId)
                                                            : null;
                                                    }, role: "row", ref: (selectedAssignee === null || selectedAssignee === void 0 ? void 0 : selectedAssignee.assigneeId) === student.assigneeId ? lastStudent : null, children: [(0, jsx_runtime_1.jsx)("td", { className: "student-status", role: "cell", children: (0, jsx_runtime_1.jsx)("button", { disabled: lernosityQuestionIsRendering, className: "btn-clearfix", "aria-label": "scored as ".concat(questionResponseStatus(student.status), " "), children: (0, jsx_runtime_1.jsx)(DpStudentsDetailsQuestionAttemptModal_styled_1.StyledDpItemBubble, { status: student.status, children: (0, jsx_runtime_1.jsx)("div", { className: "status-container", children: (0, jsx_runtime_1.jsx)("div", { className: "circle core ".concat((selectedAssignee === null || selectedAssignee === void 0 ? void 0 : selectedAssignee.assigneeId) === student.assigneeId
                                                                                ? 'active'
                                                                                : 'inactive', " "), children: (0, jsx_runtime_1.jsx)("div", { className: "icon-container", children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: getIconName(student.status) }) }) }) }) }) }) }), (0, jsx_runtime_1.jsx)("td", { role: "cell", className: " student-name ".concat((selectedAssignee === null || selectedAssignee === void 0 ? void 0 : selectedAssignee.assigneeId) === student.assigneeId
                                                                ? 'student-active'
                                                                : ''), children: (0, jsx_runtime_1.jsx)("button", { disabled: lernosityQuestionIsRendering, className: "btn-clearfix fullName", children: (0, jsx_runtime_1.jsx)(TruncatedTooltip_1.OverflowTooltip, { text: student.fullName, children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [student.fullName, " "] }) }) }) })] }, studentIndex.toString())); }) })] }) })] })] })) : isEmptyState ? ((0, jsx_runtime_1.jsxs)("div", { className: "empty-data-modal", children: [(0, jsx_runtime_1.jsx)(image_1.default, { alt: "Magnifier glass", className: "empty-state-image", src: assets_1.SvgImages.emptyStateGlass, width: 140, height: 142 }), (0, jsx_runtime_1.jsx)("h2", { className: "primary-text", children: primaryText })] })) : null }), (0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Footer, {})] })));
};
exports.DpStudentsDetailsQuestionAttemptModal = DpStudentsDetailsQuestionAttemptModal;
